import { Box, TextField as MuiTextField } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)``

export const Label = styled('label')<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    display: block;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    color: ${theme.colors.gray.dark};
    margin-bottom: 6px;
    opacity: ${disabled ? 0.6 : 1};
  `}
`

export const TextField = styled(MuiTextField)<{ error?: boolean }>`
  ${({ theme, error }) => css`
    width: 100%;

    &.MuiFormControl-root {
      width: 100%;
    }

    .MuiOutlinedInput-root {
      height: 48px;
      width: 100%;
      box-sizing: border-box;
      border-radius: 8px;

      .MuiOutlinedInput-notchedOutline {
        border: 1px solid !important;
        border-color: ${error ? theme.colors.error.color : theme.colors.gray.dark} !important;
        width: 100%;
        box-sizing: border-box;
      }

      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${error ? theme.colors.error.color : theme.colors.primary} !important;
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border: 2px solid ${error ? theme.colors.error.color : theme.colors.primary} !important;
      }
    }

    .MuiInputBase-input {
      font-size: 16px;
      padding: 14.5px 14px 11.5px;
      width: 100%;
      box-sizing: border-box;
      color: ${theme.colors.gray.dark};

      &::placeholder {
        font-size: 16px;
        opacity: 0.5;
      }
    }

    &.Mui-disabled,
    .MuiOutlinedInput-root.Mui-disabled,
    .MuiInputBase-root.Mui-disabled,
    .MuiInputBase-input.Mui-disabled {
      cursor: not-allowed !important;
    }

    .MuiOutlinedInput-root.Mui-disabled {
      background: ${theme.colors.gray.disabled} !important;
    }

    .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.colors.border.disabled} !important;
    }

    .MuiInputBase-input.Mui-disabled {
      color: ${theme.colors.gray.dark} !important;
      -webkit-text-fill-color: ${theme.colors.gray.dark} !important;
      opacity: 0.6 !important;
    }
  `}
`

export const IconWrapper = styled('span')<{ error?: boolean; disabled?: boolean }>`
  ${({ theme, error, disabled }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${error ? theme.colors.error.color : theme.colors.gray.dark};
    opacity: ${disabled ? 0.6 : 1};

    svg {
      color: inherit;
    }
  `}
`

export const ErrorMessage = styled(Box)`
  ${({ theme }) => css`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    padding: 4px 0 0 0;
    color: ${theme.colors.error.color};
  `}
`
